const Loading: React.FC = () => {
  // create a component that renders a loading spinner with tailwind classes and font awesome icons

  return (
    <div className="flex items-center justify-center bg-transparent ">
      <div className="flex items-center justify-center w-16 h-16 bg-gray-100 rounded-full">
        <i className="text-gray-500 fas fa-spinner fa-spin" />
      </div>
      در حال بارگذاری
    </div>
  );
};

export default Loading;
